/*! © 2026 AirX (airx.art). All rights reserved. Unauthorized copying, reproduction, or redistribution of this code is prohibited. Report infringement: info@airx.art */

(function () {
  'use strict';

  const CHOICE_KEY = 'airx:cookie-choice';
  const ENTRANCE_DELAY = 2000;

  const getChoice = () => {
    try { return localStorage.getItem(CHOICE_KEY); } catch (e) { return null; }
  };
  const setChoice = (value) => {
    try { localStorage.setItem(CHOICE_KEY, value); } catch (e) {}
  };

  const loadConsentApi = () =>
    new Promise((resolve) => {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        resolve(window.Shopify.customerPrivacy);
        return;
      }
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          () => resolve((window.Shopify && window.Shopify.customerPrivacy) || null)
        );
        return;
      }
      resolve(null);
    });

  class CookieBanner extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('.cookie-banner__card');
      const accept = this.querySelector('[data-consent-accept]');
      const decline = this.querySelector('[data-consent-decline]');
      if (accept) accept.addEventListener('click', () => this.setConsent(true));
      if (decline) decline.addEventListener('click', () => this.setConsent(false));

      loadConsentApi().then((privacy) => {
        this.privacy = privacy;
        if (this.shouldShow(privacy)) this.show();
      });
    }

    shouldShow(privacy) {
      if (privacy && typeof privacy.shouldShowBanner === 'function') {
        return privacy.shouldShowBanner();
      }
      if (privacy && typeof privacy.userCanBeTracked === 'function') {
        return !privacy.userCanBeTracked() && !getChoice();
      }
      return !getChoice();
    }

    show() {
      window.setTimeout(() => {
        this.hidden = false;
        window.requestAnimationFrame(() => this.classList.add('is-open'));
      }, ENTRANCE_DELAY);
    }

    setConsent(granted) {
      setChoice(granted ? 'accepted' : 'declined');
      const done = () => this.dismiss();
      const privacy = this.privacy || (window.Shopify && window.Shopify.customerPrivacy);
      if (privacy && typeof privacy.setTrackingConsent === 'function') {
        try {
          privacy.setTrackingConsent(granted, done);
        } catch (e) {
          done();
        }
      } else {
        done();
      }
      if (window.AirX && window.AirX.emit) {
        window.AirX.emit('consent:change', { granted });
      }
    }

    dismiss() {
      this.classList.remove('is-open');
      window.setTimeout(() => {
        this.hidden = true;
      }, 450);
    }
  }

  if (!customElements.get('cookie-banner')) {
    customElements.define('cookie-banner', CookieBanner);
  }
})();
